import type { ReferenceRendererProps } from '@contember/react-client'
import React from 'react'
import type { ContentBlockReference } from '../../app/data/content/ContentFragment'
import { Inspiration } from '../Inspiration'

export const inspiration = ({ reference }: ReferenceRendererProps<ContentBlockReference>) => {
	return <Inspiration headline={reference.primaryText || 'Inspirace'} />
}
